import { AlertBannerType } from '../../indigofair/data/AlertBannerType';
import { PromoModalType } from '../../indigofair/data/PromoModalType';

export namespace IAlertBanner {
  export type AlertBannerActionTypeType = 'REDIRECT' | 'OPEN_MODAL';

  export enum AlertBannerActionType {
    REDIRECT = 'REDIRECT',
    OPEN_MODAL = 'OPEN_MODAL',
  }

  export namespace IRichTextEntity {
    /**
     * Return an instance of IRichTextEntity with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<IRichTextEntity>
    ): IRichTextEntity =>
      ({
        ...(partial ?? {}),
      }) as IRichTextEntity;
  }

  export interface IRichTextEntity {
    text: string | undefined;
    route: string | undefined;
    action_type: keyof typeof IAlertBanner.AlertBannerActionType | undefined;
    promo_modal_type: keyof typeof PromoModalType | undefined;
  }

  /**
   * Redacted copy of IAlertBanner (i.e. without redacted fields).
   */
  export type Redacted = Omit<IAlertBanner, 'id'>;

  /**
   * Return an instance of IAlertBanner with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IAlertBanner>): IAlertBanner =>
    ({
      entities: {},
      ...(partial ?? {}),
    }) as IAlertBanner;
}

/**
 * A banner to display to customers on the website to give arbitrary announcements.
 */
export interface IAlertBanner {
  type: keyof typeof AlertBannerType | undefined;
  alert_banner_type_name: string | undefined;
  title: string | undefined;
  message: string | undefined;
  background_color_hex: string | undefined;
  text_color_hex: string | undefined;
  action_text: string | undefined;
  action_text_color_hex: string | undefined;
  icon_url: string | undefined;
  dismissable: boolean | undefined;
  entities: Partial<Record<string, IAlertBanner.IRichTextEntity>>;
  /**
   * On mobile, the entire element is clickable. This is the link they should navigate to.
   */
  mobile_cta_link: string | undefined;
  visible: boolean | undefined;
  /**
   * To be used only internal by the server, not for external APIs.
   * [REDACTED]
   * @protobufOption (indigofair.data.redacted) = true
   */
  id: number | undefined; // redacted
}
